<template>
  <v-card flat class="mt-4" v-if="selectedOrder">
    <v-row no-gutters>
      <v-col cols="12" md="6" v-if="machinesNames()">
        <OrderInfo @constCenter="updatePrintOrder" :selectedOrder="selectedOrder" :machines="machinesNames()" />
      </v-col>

      <v-col class="section ma-0 pa-0" cols="12" md="6">
        <v-card-title>BESTÄLLARE</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="subtitle">Företag/Namn</v-col>
            <v-col>
              <div v-if="selectedOrder.createdByType == 'Person' && selectedOrder.printType != 'TradeCertificate'">
                <div v-if="selectedOrder.companyId && selectedOrder.company && selectedOrder.company.name">
                  <router-link :to="'/companies/' + selectedOrder.companyId">{{
                    selectedOrder.company.name
                  }}</router-link>
                </div>
              </div>
              <div v-else>
                <div v-if="selectedOrder.print && selectedOrder.print.person">
                  <router-link :to="'/people/' + selectedOrder.print.person.id">{{
                    selectedOrder.print.person | fullName
                  }}</router-link>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">Org.nr./Pers.Nr.</v-col>
            <v-col>
              <div v-if="selectedOrder.createdByType == 'Person' && selectedOrder.printType != 'TradeCertificate'">
                <div
                  v-if="selectedOrder.companyId && selectedOrder.company && selectedOrder.company.organizationalNumber"
                >
                  {{ selectedOrder.company.organizationalNumber }}
                </div>
              </div>
              <div v-else>
                <div
                  v-if="selectedOrder.print && selectedOrder.print.person && selectedOrder.print.person.personalNumber"
                >
                  <div v-if="showFullPersonalNumber">
                    {{ selectedOrder.print.person.personalNumber | formatPnr }}
                  </div>
                  <div v-else>
                    {{ selectedOrder.print.person.personalNumber | formatSecretPnr }}
                    <v-icon class="ml-2" @click="showPersonalnumber()">$sl-view-on</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">Adress</v-col>
            <v-col class="mr-11">
              <div class="d-flex justify-content-between" v-if="!showEditAdress">
                <div class="mr-2"><v-icon small @click="showEditAdress = true" :disabled="!canUpdate">$sl-edit</v-icon></div>
                <div>
                  <div>{{ selectedOrder.deliveryPostalAddress }}</div>
                  <div>{{ selectedOrder.deliveryPostalAddress2 }}</div>
                  <div>{{ selectedOrder.deliveryZipCode | formatZip }},
                  {{ selectedOrder.deliveryCity }}</div>
                </div>
              </div>
              <div v-else>
                <div class="d-flex justify-content-between">
                  <div>
                    <v-text-field dense label="Adress" v-model="selectedOrder.deliveryPostalAddress" outlined />
                  </div>

                  <div class="ml-2 mt-2">
                    <v-icon
                      @click="
                        updatePrintOrder()
                        showEditAdress = false
                      "
                      >$sl-check</v-icon
                    >
                  </div>
                </div>

                <v-text-field dense label="Adress2" v-model="selectedOrder.deliveryPostalAddress2" outlined />
                <v-text-field dense label="Postnummer" v-model="selectedOrder.deliveryZipCode" outlined />
                <v-text-field dense label="Ort" v-model="selectedOrder.deliveryCity" outlined />
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">E-post för fakturering</v-col>
            <v-col class="mr-11">
              <div class="d-flex justify-content-between" v-if="!showEditInvoiceEmail">
                <div class="mr-2"><v-icon small @click="showEditInvoiceEmail = true" :disabled="!canUpdate">$sl-edit</v-icon></div>                
                <a v-if="selectedOrder.invoiceEmail" :href="`mailto:${selectedOrder.invoiceEmail}`"> {{ selectedOrder.invoiceEmail }}</a>                
                <div v-else>Ej angivet.</div>
              </div>              
              <div v-else class="d-flex justify-content-between">                  
                <v-text-field
                  ref="invoiceEmail"
                  dense
                  v-model="selectedOrder.invoiceEmail"
                  outlined
                  :rules="[rules.email]"
                />                  
                <div class="ml-2 mt-2">
                  <v-icon @click="updateInvoiceEmail">$sl-check</v-icon>
                </div>
              </div>              
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">Kontaktperson </v-col>
            <v-col>
              <div class="d-flex justify-content-between">
                <div v-if="selectedOrder.createdBy">
                  {{ selectedOrder.createdBy | fullName }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">Telefonnummer</v-col>
            <v-col>
              <div class="d-flex justify-content-between">
                <div v-if="selectedOrder.createdBy">
                  {{ selectedOrder.createdBy.mobilephone }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="subtitle">E-postadress </v-col>
            <v-col>
              <div class="d-flex justify-content-between">
                <div v-if="selectedOrder.createdBy">
                  {{ selectedOrder.createdBy.email }}
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-col>
    </v-row>

    <v-card-text>
      <v-data-table
        class="mt-10"
        :headers="headers"
        :items="[selectedOrder]"
      >
        <!-- <template v-slot:[`item.orderId`]="" v-if="item && item.printType && item.printType=='TradeCertificate'">yrkesbeviskort: </template>
        <template v-else v-slot:[`item.orderId`]="">Maskinkort: {{ machinesNames() }}</template> -->
        <template slot="item.orderId" slot-scope="props">
            {{ props.item.printType=='TradeCertificate' ? 'Yrkesbeviskort: ' + professionNames(props.item) :  'Maskinkort: ' + machinesNames() }}
        </template>

        <template v-slot:[`item.price`]="props">
          <div style="text-align: right">
            {{ props.item.price | exclFee | currency | withCurrencyCode }}
          </div>
        </template>
        
      </v-data-table>
    </v-card-text>

    <v-card-text class="my-10 subtitle">
      <div class="d-flex justify-space-between">
        <div>Summa</div>
        <div>{{ selectedOrder.price | exclFee | currency | withCurrencyCode }}</div>
      </div>
    </v-card-text>
    <v-card-text>
      <v-card-title class="invoice-amount my-10">
        <div>Fakturabelopp (exkl. moms)</div>
        <div class="ml-auto">{{ selectedOrder.price | exclFee | currency | withCurrencyCode }}</div>
      </v-card-title>
    </v-card-text>
    <v-card-actions class="mb-6">
      <v-row>
        <v-col class="pt-2 d-flex flex-wrap">
          <v-btn disabled> <v-icon>$sl-upload</v-icon>Skicka till ekonomisystem </v-btn>
          <v-btn color="secondary" disabled> <v-icon>$sl-email</v-icon>Skicka kopia med e-post </v-btn>

          <v-btn color="secondary" class="icon" @click="doDownload" :disabled="!userAdminAndKanslistCan()">
            <v-icon>$sl-download</v-icon>Ladda ned fil
          </v-btn>
          <v-btn color="secondary" @click="doPrint"> <v-icon>$sl-printer</v-icon>Skriv ut </v-btn>
          <v-btn color="secondary" @click="printInvoiceOrder()"> <v-icon>$sl-printer</v-icon>Skriv ut faktura</v-btn>
          
          <v-btn
            color="secondary"
            :style="{ marginLeft: 'auto !important' }"
            @click="deletePrintOrder()"
            v-if="canDeleteOrder"
          > 
            <v-icon>$sl-delete</v-icon>
            Radera
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AddressBox from '@/components/AddressBox'
import OrderAddOrderRow from '@/components/order/OrderAddOrderRow'
import OrderInfo from '@/components/order/OrderInfo'
import {RulesMixin, UserRules, CanIDo} from '@/components/mixins'
import API from '@/services/api.js'
import get from 'lodash/get'
import {DownloadsMixin} from '@/components/mixins'
import {PrintsMixin} from '@/components/mixins'
import pick from 'lodash/pick'

// @group Order
// PrintOrderInvoiceDetail component
export default {
  name: 'PrintOrderInvoiceDetail',

  mixins: [RulesMixin, DownloadsMixin, PrintsMixin, UserRules, CanIDo],

  components: {
    AddressBox,
    OrderInfo,
    OrderAddOrderRow
  },

  data: () => ({
    constCenter: 0,
    showEditAdress: false,
    showEditInvoiceEmail: false,
    showFullPersonalNumber: false,
    invoiceText: '',
    sendPaper: false,
    ordertable: [],
    dialog: false,
    editIndex: -1,
    editedItem: {},
    orderAddress: '-',
    headers: [
      {text: 'Order', value: 'orderId', width: '300px'},
      {text: 'Pris Exkl. Moms', value: 'price', align: 'end', sortable: false, class: 'pr-4', width: '200px'}
    ]
  }),

  created() {
    //console.log('selectedOrder.company :>> ', this.selectedOrder)
  },

  watch: {
    selectedOrder: {
      handler(val) {
        if(val?.reason) {
          this.headers.forEach(o => o.text === 'Order' ? o.text = `${ o.text } (Orsak: ${ val?.reason })` : o.text)
        }
      },
      deep: true, immediate: true
    }
  },

  computed: {
    ...mapGetters('order', ['selectedOrder']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    canDeleteOrder() {
      return get(this, 'selectedOrder.printType', null) === 'TradeCertificate' && this.isAdmin
    },

    isAdmin() {
      return get(this, 'currentUser.userrole.isAdmin', false)
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    get,

    async deletePrintOrder() {
      const printOrderId = get(this, '$route.params.id', null)
      if ( !printOrderId )
        this.$events.fire('showError', 'Saknar beställnings-id')

      const res = await this.$dialog.confirm({
        title: 'Radera beställning',
        text: 'Denna beställning kommer att raderas. Vill du fortsätta?',
        actions: [
          { text: 'Avbryt', key: false, outlined: true, icon: '$sl-cancel' },
          { text: 'Fortsätt', key: true, icon: '$sl-like', outlined: false }
        ]
      })

      if ( res !== true ) return

      API.deletePrintOrdersById(printOrderId)
        .then(() => {
          this.$router.replace({ name: 'Orders' })
          this.$events.fire('showInfo', 'Beställning raderad.')
        })
        .catch(() => this.$events.fire('showError', 'Tyvärr gick det inte att radera beställningen.'))
    },

    ...mapActions('order', ['setSelectedOrder', 'updateSelectedOrder']),
    machinesNames() {
      let machines = ''
      let machineCertificateMachines = get(this.selectedOrder, 'print.machineCertificateMachines', [])
      machineCertificateMachines.forEach(m => {
        if (machines != '') machines += ', '
        machines += m.machine.name
      })
      machines.replace(/\s*,\s*/g, ', ')
      this.selectedOrder.machines = machines
      return machines
    },
    professionNames(item){
      let ret      
      if(item.print && item.print.formattedProfessions)
      {        
        ret = item.print.formattedProfessions.replaceAll('\n', ', ')        
        if(ret.length>2 && ret[ret.length-2]==',')
        {
          ret = ret.substring(0, ret.length-2)
        }        
      }      
      return ret
    },
    constCenterVal(val) {
      this.constCenter = val
    },

    printInvoiceOrder() {
      //- Add current logged in user as the reference to invoice
      const { firstName, lastName } = this.currentUser || {}
      const order = { ...this.selectedOrder, reference: { firstName, lastName }}

      const fieldsToValidate = pick(order, ['invoicePostalAddress', 'deliveryPostalAddress'])
      
      if ( Object.values(fieldsToValidate).every(o => !o || o === '') )
        return this.$events.fire('showError', 'Fakturadress saknas')

      this.printInvoice(order)
    },

    /**
     * @vuese
     * Used to update distance order
     * @arg The argument is an integer representing  distance order id and param is state id
     */
    updatePrintOrder() {
      let updateFields = {
        costCenter: this.selectedOrder.costCenter,
        contactPerson: this.selectedOrder.contactPerson,
        deliveryCity: this.selectedOrder.deliveryCity,
        deliveryCountry: this.selectedOrder.deliveryCountry,
        deliveryPostalAddress: this.selectedOrder.deliveryPostalAddress,
        deliveryPostalAddress2: this.selectedOrder.deliveryPostalAddress2,
        deliveryZipCode: this.selectedOrder.deliveryZipCode,
        invoiceEmail: this.selectedOrder.invoiceEmail
      }

      API.updatePrintOrdersById(this.selectedOrder.id, {
        data: updateFields
      })
        .then(response => {
          this.$events.fire('showInfo', 'Sparad.')
          /**
           * @vuese
           * Used to update selected order in local store with new state id
           */
          this.updateSelectedOrder(updateFields)
        })
        .catch(error => {
          console.log('There was an error:', error)
          this.$events.fire(
            'showError',
            'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
          )
        })
    },
    // @vuese
    //- Used to download distance order xml
    doDownload() {
      API.exportDistanceOrders({
        selectedOrders: [this.selectedOrder.id],
        exportType: 'xml'
      })
        .then(response => {
          const blob = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}))
          this.downloadFile('orders.xml', blob)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },

    doPrint() {
      this.printOrder(this.selectedOrder)
    },
    /**
     * @vuese
     * Used to show mask to personal number
     */
    showPersonalnumber() {
      this.showFullPersonalNumber = true

      return new Promise(resolve => {
        setTimeout(() => {
          this.showFullPersonalNumber = false
        }, 5000)
      })
    },
    updateInvoiceEmail() {
      const isValid = this.$refs.invoiceEmail.validate()
      if (!isValid) return
      this.updatePrintOrder()
      this.showEditInvoiceEmail = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
